import FinanceSalariesView from 'components/organisms/finance-salaries/FinanceSalariesView'
import React from 'react'

const FinanceSalaries = () => {
  return (
    <FinanceSalariesView />
  )
}

export default FinanceSalaries